import React, { useReducer } from 'react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import styles from './Collapse.module.scss';

interface CollapseInterface {
  title?: string;
  className?: string;
  openItems?: JSX.Element;
  closeItem?: string | JSX.Element;
}

export const Collapse = ({ title, className, openItems, closeItem }: CollapseInterface): JSX.Element => {
  const [open, toggle] = useReducer((state) => !state, false);

  return (
    <div className={className}>
      {title && <p className={styles.title}>{title}</p>}
      <div className={cm(styles.block, { [styles.open]: open })}>
        {open ? openItems : closeItem}
        <div onClick={toggle} className={styles.arrow}>
          <Icon name="expandArrow" fill={open ? '#547DB1' : '#9EB3C8'} />
        </div>
      </div>
    </div>
  );
};
